import { __assign, __rest } from "tslib";
import React from 'react';
import Button from './button';
import LoadingSpinner from './shared/loading-spinner';
var LoadingButton = React.forwardRef(function LoadingButton(_a, ref) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, rest = __rest(_a, ["isLoading"]);
    // Button already has React.memo, so just leaning on that
    return (React.createElement(Button, __assign({}, rest, { ref: ref, overlay: isLoading ? React.createElement(LoadingSpinner, __assign({}, rest)) : null })));
});
// Tools including enzyme rely on components having a display name
LoadingButton.displayName = 'LoadingButton';
export default LoadingButton;
//# sourceMappingURL=loading-button.js.map